import { createFeatureSelector, createSelector } from '@ngrx/store';
import type { UserAccountState } from '../user-account.state';

const selectUserAccountState = createFeatureSelector<UserAccountState>('userAccount');

const selectUserPasswordState = createSelector(selectUserAccountState, (userAccount: UserAccountState) => userAccount.userPasswordState);

export const selectUserPasswordChangeStatus = createSelector(selectUserPasswordState, state => state.changeStatus);
export const selectUserPasswordChangeError = createSelector(selectUserPasswordState, state => state.changeFailureResult);
